module.exports = __webpack_public_path__ + "media/images/icons/filled/plus-square-48f838c26fc0ec28a9dd8b2f935d85c8.svg";